import { Pipe, PipeTransform } from '@angular/core';
import { ReportCategory } from '../static/reports.config';

@Pipe({
    name: 'reportAccess',
    standalone: true,
    pure: true
})
export class ReportAccessPipe implements PipeTransform {

    transform(
        categories: ReportCategory[],
        rights: any,
        isZuggit: boolean
    ): ReportCategory[] {

        if (!categories) return [];

        return categories
            .map(category => {
                const filteredReports = category.reports.filter(report => {
                    if (report.zuggitOnly && !isZuggit) return false;
                    if (!report.zuggitOnly && isZuggit) return false;
                    if (!report.permission) return true;

                    return rights?.[report.permission];
                });
                return {
                    ...category,
                    reports: filteredReports
                };
            })
            .filter(category => category.reports.length > 0);
    }
}
